import { ResetPasswordContainer } from '@/containers/auth/reset-password-container';
import Footer from '@/components/organisms/Footer';
import { ChevronLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const ResetPasswordPage = () => {
  const navigate = useNavigate();

  return (
    <div className="scrollbar flex flex-col overflow-y-auto bg-gr-50 max-md:bg-white">
      <div className="flex h-[100dvh] flex-col items-center pt-[clamp(80px,20vh,272px)] max-md:pt-10">
        <div className="space-y-5 max-md:w-full">
          <button className="flex items-center gap-3 max-md:px-5" onClick={() => navigate(-1)}>
            <ChevronLeftIcon className="h-8 w-8 max-md:h-6 max-md:w-6" />
            <div className="text-gr-900 Title2S24 max-md:Body1S16">비밀번호 재설정</div>
          </button>
          <ResetPasswordContainer />
        </div>
      </div>
      <Footer />
    </div>
  );
};
